import { useEffect } from 'react';
import { map } from 'lodash';

import { isBlogPostProject, isLongFormProject } from 'src/data/project';
import { DRAFT_TOV_ID } from 'src/data/toneOfVoice';
import { useBrandVoicesAssets, useProjectActions } from 'src/store';

export const useFallbackToDefaultTov = ({ selectedCustomModelId, projectType }) => {
  const projectActions = useProjectActions();

  const { customModels, toneOfVoices, loadingBrandVoiceAssets } = useBrandVoicesAssets();

  useEffect(() => {
    if (!selectedCustomModelId) {
      return;
    }
    const selectedCustomModel = customModels.find((cm) => cm.id === selectedCustomModelId);

    if (!selectedCustomModel) {
      projectActions.clearSelectedCustomModelId();
    }
  }, [selectedCustomModelId, customModels, projectActions]);

  useEffect(() => {
    if (loadingBrandVoiceAssets) {
      return;
    }
    const selectedTov = projectActions.getSelectedTov();

    const toneOfVoicesIds = map(toneOfVoices, 'id');

    if (
      !toneOfVoicesIds.includes(selectedTov) &&
      selectedTov !== DRAFT_TOV_ID &&
      !isLongFormProject(projectType) &&
      !isBlogPostProject(projectType)
    ) {
      projectActions.clearTovInputs();
    }
  }, [loadingBrandVoiceAssets, toneOfVoices, projectActions, projectType]);
};
